// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___3MpCG","content":"content___3XsnM"};